import { DonutChartData, DonutLegendItem } from '../../../../shared/components/DonutCharts'
import { ReactComponent as CircleIcon } from '../../../../assets/images/shapes/circle.svg'
import { ReactComponent as TriangleDownIcon } from '../../../../assets/images/shapes/triangle-down.svg'
import { filterEmptyDonutCategories } from '../../../../shared/components/DonutCharts/hooks/filterEmptyCategories'
import { FIGMA_ACCENT_COLORS } from '../../../../style/colors'
import { Deliverable, useGetDeliverablesQuery } from '../../../../shared/queries/metrics/useGetDeliverablesQuery'
import { useMemo } from 'react'

// @TODO metrics - dynamic legend
const legend: DonutLegendItem[] = [
    { id: 'Ongoing', label: 'Ongoing', color: FIGMA_ACCENT_COLORS.blue, icon: TriangleDownIcon },
    { id: 'Completed', label: 'Completed', color: FIGMA_ACCENT_COLORS.green, icon: CircleIcon },
]

const useDeliverableMetrics = () => {
    const getDeliverablesQuery = useGetDeliverablesQuery()

    const data = useMemo((): DonutChartData<Deliverable>[] => {
        if (!getDeliverablesQuery.data) {
            return []
        }

        return getDeliverablesQuery.data.map(({ grouping: title, items: statuses }) => {
            const values = legend.map((legendItem) => {
                const items = statuses[legendItem.label] || []
                return { items, count: items.length, label: legendItem.label }
            })
            return { title, values }
        })
    }, [getDeliverablesQuery.data])

    const { filteredLegend, filteredData } = useMemo(() => filterEmptyDonutCategories(legend, data), [data])

    return {
        legend: filteredLegend,
        data: filteredData,
        isLoading: getDeliverablesQuery.isLoading,
    }
}

export default useDeliverableMetrics
